import {Component, OnDestroy, OnInit} from '@angular/core';
import {DirectoryService} from '../../../../services/directory.service';
import {Resident} from '../../../../types/data.types';
import {UrlService} from '../../../../services/url.service';
import {AbstractListComponent} from '../abstract-list.component';
import {PhoneTransformer} from '../../../../services/transformer.service';
import {EmptyRowService} from '../../../../services/empty-row.service';

@Component({
    selector: 'residents-list',
    templateUrl: './residents-list.component.html',
    styleUrls: ['./residents-list.component.scss']
})
export class ResidentsListComponent extends AbstractListComponent implements OnInit, OnDestroy {

    constructor(
        public directoryService: DirectoryService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService
    ) {
        super(directoryService, urlService, emptyRowService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.s.push(this.directoryService.onDataReceived.subscribe((response) => {
            if (response.id !== 'residents') return;
            this.data = [];
            const entities = response.data.entities || [];
            this.data = [...this.directoryService.residentFactory(entities)];
            if (this.directoryService.selectedItemData && this.directoryService.selectedItemData.checked) {
                const selectedItem = this.data.find(item => item.id == this.directoryService.selectedItemData.id);
                if (selectedItem) this.directoryService.toggleDetailedView(selectedItem, true);
            }
            this.emptyRowService.fillEmptyRow();
        }));
    }

    ngOnDestroy() {
        this.directoryService.showDetailedView = false;
        this.directoryService.selectedItemData = null;
    }

    getPrimaryPhone(resident: Resident): string {
        for (let i = 0; i < resident.phones.length; i++) {
            if (resident.phones[i].isPrimaryPhone) {
                if (resident.phones[i].phone.match('^[0-9]+$'))
                    return PhoneTransformer.stringToPhone(resident.phones[i].phone);
                else
                    return resident.phones[i].phone.substr(0, resident.phones[i].phone.length);
            }
        }
        return '';
    }

    toggleCheck(item) {
        const building = this.directoryService.buildings.find(b => b.id == item.buildingId);
        if (building && building.corporationNumber) {
            this.directoryService.getCorporationSettings(building.corporationNumber);
            if (this.directoryService.account.canRead('sms')) {
                this.directoryService.getCorporationSmsSettings(building.corporationNumber);
            }
        }
        super.toggleCheck(item);
    }

    usingWaiverType(type) {
        return this.data.some(i => (<any>i).cNSettings && (<any>i).cNSettings['use' + type + 'Waiver']);
    }

    getLabelRole(role): any {
        return this.directoryService.residentOccupancyTypes.map(r => {
            r.class = r.code.replace('_', '-') + '-label';
            return r;
        }).find(el => el.code == role);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/residents-list/residents-list.component.ts